// filepath: /Users/sauravupreti/Desktop/xasino/xasino-frontend/src/components/common/ProtectedRoute.tsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission?: {
    action: string;
    tableName: string;
  };
  requiredPermissions?: Array<{
    action: string;
    tableName: string;
  }>;
  requireAny?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermission,
  requiredPermissions,
  requireAny = false,
}) => {
  const { isAuthenticated, isLoading, hasPermission, hasAnyPermission } =
    useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check permissions if required
  if (requiredPermission) {
    if (
      !hasPermission(requiredPermission.action, requiredPermission.tableName)
    ) {
      return (
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Access Denied
            </h2>
            <p className="text-gray-600">
              {`You dont have permission to access this resource.`}
            </p>
          </div>
        </div>
      );
    }
  }

  if (requiredPermissions && requiredPermissions.length > 0) {
    const hasAccess = requireAny
      ? hasAnyPermission(requiredPermissions)
      : requiredPermissions.every(({ action, tableName }) =>
          hasPermission(action, tableName),
        );

    if (!hasAccess) {
      return (
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Access Denied
            </h2>
            <p className="text-gray-600">
              You dont have permission to access this resource.
            </p>
          </div>
        </div>
      );
    }
  }

  return <>{children}</>;
};
